export default function initSiteScripts() {
  const cleanups = [];
  const timeouts = [];

  const navBtn = document.getElementById('mobileMenuButton');
  const navMenu = document.getElementById('navMenu');
  const header = document.getElementById('siteHeader');
  const toTop = document.getElementById('toTop');
  const year = document.getElementById('currentYear');

  if (year) year.textContent = String(new Date().getFullYear());

  // Mobile menu
  if (navBtn && navMenu) {
    const onNavBtnClick = () => {
      const isOpen = navMenu.classList.toggle('open');
      navBtn.setAttribute('aria-expanded', String(isOpen));
    };
    navBtn.addEventListener('click', onNavBtnClick);
    cleanups.push(() => navBtn.removeEventListener('click', onNavBtnClick));

    navMenu.querySelectorAll('a').forEach(a => {
      const onNavLinkClick = () => {
        if (window.matchMedia('(max-width: 720px)').matches) {
          navMenu.classList.remove('open');
          navBtn.setAttribute('aria-expanded', 'false');
        }
      };
      a.addEventListener('click', onNavLinkClick);
      cleanups.push(() => a.removeEventListener('click', onNavLinkClick));
    });
  }

  // Header shadow + toTop
  const onScroll = () => {
    const y = window.scrollY || document.documentElement.scrollTop;
    if (header) header.style.boxShadow = y > 8 ? '0 10px 30px rgba(9,19,38,.08)' : 'none';
    if (toTop) toTop.classList.toggle('show', y > 600);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  cleanups.push(() => window.removeEventListener('scroll', onScroll));
  onScroll();

  if (toTop) {
    const onToTopClick = () => window.scrollTo({ top: 0, behavior: 'smooth' });
    toTop.addEventListener('click', onToTopClick);
    cleanups.push(() => toTop.removeEventListener('click', onToTopClick));
  }

  // Smooth anchor scroll
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    const onAnchorClick = (e) => {
      const id = link.getAttribute('href');
      if (!id || id === '#') return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    link.addEventListener('click', onAnchorClick);
    cleanups.push(() => link.removeEventListener('click', onAnchorClick));
  });

  // Reveal on scroll
  const revealEls = Array.from(document.querySelectorAll('.reveal'));
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('in');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  revealEls.forEach(el => io.observe(el));
  cleanups.push(() => io.disconnect());

  // Count-up stats
  const counters = Array.from(document.querySelectorAll('[data-count]'));
  const counterIO = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const end = Number(el.getAttribute('data-count') || '0');
      const duration = 900;
      const start = performance.now();

      const tick = (now) => {
        const p = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        const val = Math.round(end * eased);

        let suffix = '+';
        if (end === 518);
        if (end === 100) suffix = '%';
        el.textContent = String(val) + suffix;

        if (p < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
      counterIO.unobserve(el);
    });
  }, { threshold: 0.25 });
  counters.forEach(el => counterIO.observe(el));
  cleanups.push(() => counterIO.disconnect());

  // Testimonials carousel
  const track = document.getElementById('testimonialTrack');
  const prev = document.getElementById('tPrev');
  const next = document.getElementById('tNext');
  const dotsWrap = document.getElementById('testimonialDots');

  if (track) {
    const slides = Array.from(track.querySelectorAll('.testimonial'));
    let index = 0;
    let autoTimer = null;

    const setDots = () => {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.className = 'dot-btn' + (i === index ? ' active' : '');
        b.setAttribute('aria-label', `Ir para depoimento ${i + 1}`);
        const onDotClick = () => goTo(i, true);
        b.addEventListener('click', onDotClick);
        cleanups.push(() => b.removeEventListener('click', onDotClick));
        dotsWrap.appendChild(b);
      });
    };

    const updateDots = () => {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.dot-btn').forEach((d, i) => d.classList.toggle('active', i === index));
    };

    const goTo = (i, user) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      updateDots();
      if (user) restartAuto();
    };

    const restartAuto = () => {
      if (autoTimer) clearInterval(autoTimer);
      autoTimer = setInterval(() => goTo(index + 1, false), 6500);
    };

    if (prev) {
      const onPrev = () => goTo(index - 1, true);
      prev.addEventListener('click', onPrev);
      cleanups.push(() => prev.removeEventListener('click', onPrev));
    }
    if (next) {
      const onNext = () => goTo(index + 1, true);
      next.addEventListener('click', onNext);
      cleanups.push(() => next.removeEventListener('click', onNext));
    }

    const onTrackScroll = () => {
      const newIndex = Math.round(track.scrollLeft / track.clientWidth);
      if (newIndex !== index) {
        index = newIndex;
        updateDots();
      }
    };
    track.addEventListener('scroll', onTrackScroll, { passive: true });
    cleanups.push(() => track.removeEventListener('scroll', onTrackScroll));

    setDots();
    restartAuto();
    cleanups.push(() => {
      if (autoTimer) clearInterval(autoTimer);
    });
  }

  // Contact form feedback (demo only)
  const form = document.getElementById('contactForm');
  if (form && form.hasAttribute('data-demo')) {
    const onSubmit = (e) => {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (!btn) return;
      const original = btn.textContent;
      btn.textContent = 'Enviando...';
      btn.disabled = true;

      const t1 = setTimeout(() => {
        btn.textContent = 'Mensagem enviada!';
        const t2 = setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
          form.reset();
        }, 1200);
        timeouts.push(t2);
      }, 700);
      timeouts.push(t1);
    };

    form.addEventListener('submit', onSubmit);
    cleanups.push(() => form.removeEventListener('submit', onSubmit));
  }

  return () => {
    timeouts.forEach(t => clearTimeout(t));
    cleanups.forEach(fn => fn());
  };
}
